/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestConflicted({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4.4 1.5A.6.6 0 0 1 5 .9h6a.6.6 0 1 1 0 1.2H8.72l1.817 3.632A.6.6 0 0 1 10 6.6H6.923l1.48 3.331a2.6 2.6 0 1 1-1.262.114l-1.69-3.801A.6.6 0 0 1 6 5.4h3.03L7.462 2.268a.6.6 0 0 1-.055-.168H5a.6.6 0 0 1-.6-.6Zm3.589 9.6a1.4 1.4 0 1 0 .022 2.8 1.4 1.4 0 0 0-.022-2.8Z" clipRule="evenodd" /></svg>;
}
;